import { kitMessages, useTranslate } from '@classgo/app-kit';

import { staffMessages } from './messages/es-co';

/**
 * The console's catalogue: the kit's strings plus its own.
 */
export const messages = { ...kitMessages, ...staffMessages } as const;

/**
 * The translate function typed by the console's keys.
 *
 * @returns `t(key, params)`.
 */
export const useT = () => useTranslate<keyof typeof messages>();
